import * as types from 'modules/kiosks/actionTypes';
import type { FetchKiosksByPaymentTypesSuccessAction } from 'modules/kiosks/types';
import { createReducer } from 'utils/ReduxUtils';

type KiosksByDealerIdReducer = Record<string, string[]>;

const initialState: KiosksByDealerIdReducer = {};

const setByDealerId = (
  state: KiosksByDealerIdReducer,
  { payload }: FetchKiosksByPaymentTypesSuccessAction
): KiosksByDealerIdReducer => ({
  ...state,
  [payload.dealerId]: payload.kiosks.content.map(({ id }) => id),
});

export default createReducer(initialState, {
  [types.FETCH_KIOSKS_BY_PAYMENT_TYPES_SUCCESS]: setByDealerId,
});
